import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export type ClientLogLevel = 'info' | 'warn' | 'error';

@Injectable({ providedIn: 'root' })
export class ClientLoggerService {
  private readonly endpoint = `${environment.apiBaseUrl}/api/v1/frontend-logs/client`;

  constructor(private readonly http: HttpClient) {}

  info(source: string, message: string, context?: Record<string, unknown>): void {
    this.send('info', source, message, context);
  }

  warn(source: string, message: string, context?: Record<string, unknown>): void {
    this.send('warn', source, message, context);
  }

  error(source: string, message: string, context?: Record<string, unknown>): void {
    this.send('error', source, message, context);
  }

  event(source: string, eventName: string, context?: Record<string, unknown>): void {
    this.send('info', source, `[EVENT] ${eventName}`, context);
  }

  private send(level: ClientLogLevel, source: string, message: string, context?: Record<string, unknown>): void {
    this.http.post(this.endpoint, {
      level,
      source: source || 'DMTT_RETURNS_PORTAL',
      message,
      context,
    }).subscribe({ error: () => undefined });
  }
}